import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import useGetApps from "../hooks/useGetAppList";
import App from "../components/Apps/App";
import Modal from "../components/utils/Modal";
import { AppsContext } from "../context/AppsContext";



const Apps = () => {

    const [classSelectionModal, setClassSelectionModal] = useState<boolean>(false);
    const navigate = useNavigate();

    const { app, setApp, apps, setApps } = useContext(AppsContext);

    const handleAppClick = (selectedAppData) => {
        setApp(selectedAppData);
        if (selectedAppData.type == 2) {
            setClassSelectionModal(true);
        } else {
            navigate("/math", { state: selectedAppData });
        }
    }
    const { getAppsList, chaptersList: appsList, loading } = useGetApps();

    useEffect(() => {
        if (apps.length === 0) {
            getAppsList([]);
        }
    }, []);

    useEffect(() => {
        if (!loading && appsList.length > 0) {
            console.log("did this")
            setApps(appsList);
        }
    }, [loading]);

    const ClassSelector = () => {
        const ClassLi = ({ classNumber, color }) => {

            return (
                <div
                    className={`rounded-md p-10 ${color} text-white`}
                >{classNumber}</div>
            )
        }
        return (
            <div className="bg-customBg p-2 rounded-md z-0">
                <div
                    className="flex flex-col md:flex-row gap-5"
                >
                    <Link
                        to={"/math"}
                        onClick={() => {
                            setApp({
                                ...app,
                                class: 8
                            })
                        }}
                    >
                        <ClassLi classNumber={"8th"} color={"bg-customBlue"} />
                    </Link>
                    <Link
                        to={"/math"}
                        onClick={() => {
                            setApp({
                                ...app,
                                class: 9
                            })
                        }}
                    >
                        <ClassLi classNumber={"9th"} color={"bg-customAmber"} />
                    </Link>
                    <Link
                        to={"/math"}
                        onClick={() => {
                            setApp({
                                ...app,
                                class: 10
                            })
                        }}
                    >
                        <ClassLi classNumber={"10th"} color={"bg-customSalmon"} />
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <>
            <Modal visible={classSelectionModal} onClose={() => setClassSelectionModal(false)}>
                <ClassSelector />
            </Modal>
            <div className="p-16 h-[90vh] w-full bg-customBg overflow-scroll">
                <div className="font-bold text-xl mb-5">Apps</div>
                <div className="flex flex-wrap justify-around gap-5">
                    {loading ? "Loading..." :
                        apps.map((app, index) => {
                            return <App
                                handleAppClick={handleAppClick}
                                appData={app}
                                key={index}
                            />
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default Apps;